/* eslint no-use-before-define: 0 */
const _ = require('lodash');

const diff = require('../utils/diff');
/*:: type Setting = {
  desc: String,
  value: Any,
  group: String,
  schema: String,
  key: String,
  enum?: Array<string>
}*/

/*:: type SettingGroup = {
  group: String,
  settings: Array<Setting>
}*/

/*:: type SettingInitObj = {
  desc: String,
  value: Any,
  group: String,
  schema: String
}*/


class Plan {
  /*:: static fromJson: (Object) => Plan */

  /*:: static toJson: (Plan) => Object */
  constructor({
    /*: {
        id?: ?string,
        sid?: ?string,
        name: string,
        description: string,
        settings: Array<SettingInitObj>,
        discoverable: boolean,
        enabled: boolean
      }*/

    id,
    sid,
    name,
    description,
    settings,
    discoverable,
    enabled
  } = {}) {
    this.id = id;
    this.name = name || sid;
    this.description = description;
    this.settings = parseSettingValues(settings);
    this.settingGroups = parseSettingGroups(settings);
    this.discoverable = !!discoverable;
    this.enabled = !!enabled;
  }

  clone() {
    const clonedPlan = new Plan({
      id: this.id,
      sid: this.sid,
      name: this.name,
      settings: [],
      description: this.description,
      discoverable: this.discoverable,
      enabled: this.enabled
    });
    clonedPlan.settings = _.cloneDeep(this.settings);
    clonedPlan.settingGroups = _.cloneDeep(this.settingGroups);
    return clonedPlan;
  }

  diff(otherPlan
  /*: Plan*/
  )
  /*: Object*/
  {
    // return stuff that's changed in otherPlan
    const baseDiff = diff(this, otherPlan);
    delete baseDiff.settingGroups; // always different and we don't care
    // Settings is a single field and must all cannot be partially updated

    const settingsUnchanged = _.isEqual(this.settings, otherPlan.settings);

    if (settingsUnchanged) {
      delete baseDiff.settings;
    } else {
      baseDiff.settings = otherPlan.settings;
    }

    return baseDiff;
  }

}

Plan.fromJson = (json
/*: Object*/
) => new Plan({
  id: json.id,
  sid: json.sid,
  name: json.name,
  description: json.desc,
  settings: json.settings,
  discoverable: json.discoverable,
  enabled: json.enabled
});

Plan.toJson = (plan
/*: Plan*/
) => (
/*: Object*/
{
  id: plan.id,
  name: plan.name,
  desc: plan.description,
  settings: serializeSettings(plan.settings),
  discoverable: plan.discoverable,
  enabled: plan.enabled
});

const serializeSettings = settings => {
  if (!settings) return undefined;
  return _.mapKeys(settings, (__, key) => unescapeKey(key));
};

const parseSettingValues = (settingsJson
/*: Object*/
) =>
/*: Object*/
_.chain(settingsJson).map(({
  name,
  value
}) => [escapeKey(name), value]).fromPairs().value();

const parseSettingGroups = (settingsJson
/*: Object*/
) =>
/*: Array<SettingGroup>*/
{
  const settings = settingsJson.map(setting => ({
    key: escapeKey(setting.name),
    desc: setting.desc,
    group: setting.group,
    schema: setting.schema,
    value: setting.value,
    enums: setting.enums
  }));

  const groupedSettings = _.groupBy(settings, 'group');

  return Object.values(_.mapValues(groupedSettings, (value, key) => ({
    group: key,
    settings: value
  })));
};

const escapeKey = key => key.replace(/\./g, '__');

const unescapeKey = key => key.replace(/__/g, '.');

module.exports = Plan;